/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import TemplateModel from 'cio/models/template';
import { getTemplateName } from 'cio/utils/in-app/message-config';
import { InAppStaticTemplate } from 'cio/services/in-app-static-templates';

interface InAppChooseTemplatePreviewModalSignature {
  Args: {
    template?: TemplateModel | InAppStaticTemplate;
    isSelecting: boolean;
    onSelect: () => void;
    closePreview: () => void;
  };
  Element: HTMLDivElement;
}

export default class InAppChooseTemplatePreviewModal extends Component<InAppChooseTemplatePreviewModalSignature> {
  @tracked isLoaded = false;

  @action
  didLoadPreview() {
    this.isLoaded = true;
  }

  get name() {
    if (this.isStaticTemplate) {
      return this.args.template?.name;
    }
    return getTemplateName(this.args.template as TemplateModel);
  }

  get isStaticTemplate() {
    return this.args.template instanceof InAppStaticTemplate;
  }
}
